export default function truncate(string = '', size = 0) {
  if (size > 0 === false) return string;
  if (string.length <= size + 1) {
    return string;
  }
  let truncated = '';
  string.split(' ').find(function (word) {
    if (truncated.length + word.length + 3 <= size + 1) {
      truncated += word + ' ';
    } else {
      truncated = truncated.trim() + '...';
      return true;
    }
  });
  if (truncated.length < size * 0.7) {
    return string.slice(0, size - 3) + '...';
  }
  return truncated;
}
